let sideloadCounter = 0;

/**
 * Generates a unique ID for sideloaded extensions.
 * Uses an auto-incrementing counter to ensure uniqueness.
 *
 * @returns A unique sideload ID in the format "sideload-{counter}"
 */
export const generateSideloadId = (): string => {
  sideloadCounter += 1;
  return `sideload-${sideloadCounter}`;
};

/**
 * Resets the sideload counter. Used for testing purposes.
 */
export const resetSideloadCounter = (): void => {
  sideloadCounter = 0;
};
